<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone esquerda"><a @click="this.$router.back();" style="cursor: pointer;"
                    class="icone-voltar m-d"></a></div>
            <h2>Reunião</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="margem bloco">
            <fieldset class="grid-4 margem bloco">
                <div>
                    <label>Data</label>
                    <input type="date" v-model="reunião.data" :required="!reunião.data"
                        @change="alteraçãoPendente = true" />
                </div>
                <div>
                    <label>Hora</label>
                    <input type="time" v-model="reunião.hora" :required="!reunião.hora"
                        @change="alteraçãoPendente = true" />
                </div>
                <div>
                    <label>Responsável</label>
                    <select v-model="reunião.responsavel" :required="!reunião.responsavel"
                        @change="alteraçãoPendente = true">
                        <option v-for="u in usuarios" :key="u.id" :value="u">{{ u.nome }}</option>
                    </select>
                </div>
                <div>
                    <label>Tipo</label>
                    <select v-model="reunião.tipo" :required="!reunião.tipo" @change="alteraçãoPendente = true">
                        <option v-for="i in tipos" :key="i.id" :value="{ id: i.id, descricao: i.descricao }">{{
                            i.descricao }}</option>
                    </select>
                </div>
                <div>
                    <label>Local da Reunião</label>
                    <input type="text" v-model="reunião.local" :required="!reunião.local"
                        @change="alteraçãoPendente = true" />
                </div>
                <div :class="modoCriação ? 'col-2' : ''">
                    <label>{{ modoCriação ? 'Setores' : 'Setor' }} <i title="É necessário ao menos um setor"
                            v-if="reunião.setores?.length == 0" class="bi-exclamation-diamond-fill"></i></label>
                    <div class="tags" v-if="modoCriação">
                        <a v-for="s, index in reunião.setores" :key="index">{{ formatarNome(s.nome) }}<i
                                @click="removerSetor(s.id)" class="bi-trash"></i></a>
                        <a class="container-adicionar-setor">
                            <select class="adicionar-setor" style="width: 9rem;" v-model="novoSetor"
                                @change="novoSetor == 'todos' ? (reunião.setores = setores, novoSetor = null)  : adicionarSetor()">
                                <option :value="null" hidden>Adicionar Setor</option>
                                <option :value="'todos'">Todos</option>
                                <option
                                    v-for="item in setores.filter(s => !reunião.setores.map(i => i.id).includes(s.id))"
                                    :key="item.id" :value="item">
                                    {{ item.nome }}
                                </option>
                            </select>
                        </a>
                    </div>
                    <div v-else-if="reunião.setor">
                        <select v-model="reunião.setor.id" @change="alteraçãoPendente = true">
                            <option v-for="item in setores" :key="item.id" :value="item.id">
                                {{ item.nome }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-4">
                    <label>Assunto</label>
                    <textarea v-model="reunião.assunto" :required="!reunião.assunto"
                        @change="alteraçãoPendente = true"></textarea>
                </div>
            </fieldset>
            <div class="bloco margem">
                <h3>Anexos</h3>
                <div class="tags submit">
                    <a v-for="a, index in reunião.anexos" :key="index" target="_blank"
                        :title="a.obrigatorio || a.tema == 1 ? 'Este anexo foi herdado de um tema e não pode ser excluído' : ''"
                        :href="a.path ? `${urlFoto}/${a.path}` : null">{{ a.name ?? a.nome }}
                        <i v-if="!a.obrigatorio && a.tema == 0" @click.stop.prevent="removerAnexo(a)"
                            class="bi-trash"></i>
                    </a>
                    <a @click="abrirInput">+</a>
                    <input style="display: none" ref="fileInput" type="file" @change="adicionarArquivo">
                </div>
            </div>
            <div class="bloco margem">
                <h3>Pautas <i title="É necessário ao menos uma pauta" v-if="reunião.pautas?.length == 0"
                        class="bi-exclamation-diamond-fill"></i>
                </h3>
                <fieldset class="grid-1">
                    <div v-for="p, index in reunião.pautas" :key="index">
                        <div style="justify-content: space-between" class="alinha-v">
                            <label>Pauta {{ index + 1 }} <i v-if="p.obrigatorio || p.observacao"
                                    title="Esta pauta foi herdada de um tema e não pode ser modificada"
                                    class="bi-exclamation-circle"></i></label>
                            <i class="bi-x-circle" v-if="!p.obrigatorio && !p.observacao" @click="removerPauta(p)"></i>
                        </div>
                        <textarea v-model="p.descricao" :readonly="p.obrigatorio || p.observacao"
                            @change="alteraçãoPendente = true" :required="!p.descricao"></textarea>
                    </div>
                </fieldset>
                <div class="submit">
                    <button class="acao-secundaria" @click="adicionarPauta()">Adicionar</button>
                </div>
            </div>
            <div class="submit direita">
                <button @click="modoCriação ? gravarReuniao() : atualizarReunião()"
                    :disabled="composVazios || !alteraçãoPendente"
                    :title="!alteraçãoPendente ? 'Nenhuma alteração pendente' : composVazios ? 'Preencha os campos destacados' : ''">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
import service from '@/services/serviceReuniões';
import { getSetoresHieraquico } from "@/services/serviceSetores.js";
import { urlFoto } from "@/services/api"
import { ref } from 'vue'

export default {
    props: {
        id: {
            required: true,
        },
    },
    data() {
        return {
            novoSetor: null,
            reunião: {},
            setores: [],
            tipos: [],
            usuarios: [],
            urlFoto: urlFoto.caminhoFoto,
            alteraçãoPendente: false,
        }
    },
    computed: {
        modoCriação() {
            return this.id == 'criar'
        },
        composVazios() {
            const camposParaValidar = ['data', 'hora', 'local', 'assunto', 'tipo', 'responsavel'];
            var camposVazios = []
            camposParaValidar.forEach(campo => {
                if (this.reunião[campo] == null || this.reunião[campo] == '') {
                    camposVazios.push(campo)
                }
            })
            if (this.reunião.setores?.length == 0) {
                camposVazios.push('setores')
            }
            if (this.reunião.pautas?.length == 0) {
                camposVazios.push('pautas')
            } else {
                this.reunião.pautas?.forEach(pauta => {
                    if (pauta.descricao == null || pauta.descricao == '') {
                        camposVazios.push('pautas')
                    }
                })
            }
            return camposVazios.length > 0
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.alteraçãoPendente) {
            const resposta = window.confirm('Você tem alterações não salvas. Deseja sair mesmo assim?');
            if (resposta) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    },
    async created() {
        this.buscarReunião();
        this.setores = await getSetoresHieraquico()
        this.setores = this.setores.map(setor => ({
            id: setor.id,
            nome: this.formatarNome(setor.nome)
        })).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
        this.tipos = await service.getTipos();
        this.usuarios = await service.getUsuarios()
    },
    mounted() {
        window.addEventListener('beforeunload', this.alertaSaida);
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.alertaSaida);
    },
    setup() {
        const fileInput = ref(null);

        const abrirInput = () => {
            fileInput.value.click();
        };

        return { fileInput, abrirInput };
    },
    watch: {
        'reunião.setores': {
            handler: 'checarTemas',
            deep: true
        },
        'reunião.tipo': {
            handler: 'checarTemas',
            deep: true
        },
    },
    methods: {
        formatarNome(nome) {
            return nome.replace(/^(\d+\.*\s*)+/, '')
        },
        alertaSaida(event) {
            if (this.alteraçãoPendente) {
                event.preventDefault();
                event.returnValue = '';
            }
        },
        async atualizarReunião() {
            const formData = new FormData();
            formData.append('status', 1);
            formData.append('tipo', this.reunião.tipo?.id);
            formData.append('responsavel_id', this.reunião.responsavel?.id);
            formData.append('setor', this.reunião.setor?.id);
            formData.append('hora', this.reunião.hora?.slice(0, 5));
            formData.append('_method', 'PATCH');

            this.reunião.pautas.forEach((pauta, index) => {
                if (pauta.id) {
                    formData.append(`pautas[${index}][id]`, pauta.id);
                    if (!pauta.observacao) {
                        formData.append(`pautas[${index}][descricao]`, pauta.descricao);
                    }
                } else {
                    formData.append(`pautas[${index}][descricao]`, pauta.descricao);
                }
            });

            for (let key in this.reunião) {
                if (['setores', 'pautas', 'tipo', 'anexos', 'responsavel', 'anexosTema', 'setor', 'status', 'id', 'participantes', 'hora'].includes(key)) continue;
                const value = this.reunião[key];
                if (value !== null && value !== undefined) {
                    formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
                }
            }

            this.reunião.anexos.filter(a => !a.anexoNovo && a.tema != 1).forEach((file, index) => {
                formData.append(`anexosExistentes[${index}]`, file.id);
            });

            this.reunião.anexos.filter(a => a.anexoNovo).forEach((file, index) => {
                formData.append(`anexosNovos[${index}]`, file);
            });

            await service.atualizarReunião(this.id, formData);
            this.alteraçãoPendente = false
        },
        async gravarReuniao() {
            const formData = new FormData();
            formData.append('status', 2);
            formData.append('tipo', this.reunião.tipo?.id);
            formData.append('responsavel_id', this.reunião.responsavel?.id);
            this.reunião.setores.forEach((setor, index) => {
                formData.append(`setores[${index}]`, setor.id);
            });
            this.reunião.pautas.forEach((pauta, index) => {
                if (pauta.id) {
                    formData.append(`pautas[${index}][id]`, pauta.id);
                    formData.append(`pautas[${index}][observacoes]`, true);
                } else {
                    formData.append(`pautas[${index}][descricao]`, pauta.descricao);
                }
            });

            for (let key in this.reunião) {
                if (['setores', 'pautas', 'tipo', 'anexos', 'responsavel', 'anexosTema'].includes(key)) continue;

                const value = this.reunião[key];
                if (value !== null && value !== undefined) {
                    formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
                }
            }

            this.reunião.anexos.filter(a => !a.obrigatorio).forEach((file, index) => {
                if (file.id) {
                    formData.append(`anexos[${index}][id]`, file.id);
                } else {
                    formData.append(`anexos[${index}]`, file);
                }
            });

            this.reunião.anexos.filter(a => a.obrigatorio).forEach((anexo, index) => {
                formData.append(`anexosTema[${index}]`, anexo.id);
            });

            await service.gravarReunião(formData);
            this.alteraçãoPendente = false
            this.$router.push({ name: 'agendaReunioesView' });
        },
        async checarTemas() {
            if (this.id !== 'criar') {
                return
            }
            if (!this.reunião.tipo?.id || this.reunião.setores.length == 0) {
                this.reunião.pautas = this.reunião.pautas.filter(p => !p.obrigatorio)
                this.reunião.anexos = this.reunião.anexos.filter(a => !a.obrigatorio)
                return
            }
            var payload = {
                setores: this.reunião.setores.map(i => i.id) ?? [],
                tipo: this.reunião.tipo?.id ?? null
            }
            const response = await service.buscarPautaTemporarias(payload);
            if (response) {
                this.reunião.pautas = [
                    ...this.reunião.pautas.filter(p => !p.obrigatorio),
                    ...response.pautas.map(i => ({ ...i, obrigatorio: true })),
                ];

                this.reunião.anexos = [
                    ...this.reunião.anexos.filter(a => !a.obrigatorio),
                    ...response.anexos.map(i => ({ ...i, obrigatorio: true })),
                ];

            } else {
                this.reunião.pautas = this.reunião.pautas.filter(i => !i.obrigatorio)
                this.reunião.anexos = this.reunião.anexos.filter(i => !i.obrigatorio)
            }
        },
        async buscarReunião() {
            this.reunião = await service.buscarReunião(this.id);
        },
        adicionarPauta() {
            var pauta = { descricao: '' }
            this.reunião.pautas.push(pauta)
        },
        removerPauta(pauta) {
            this.reunião.pautas = this.reunião.pautas.filter(p => p != pauta)
            this.alteraçãoPendente = true;
        },
        adicionarArquivo(event) {
            event.target.files[0].anexoNovo = true
            event.target.files[0].tema = 0
            this.reunião.anexos.push(event.target.files[0]);
            this.alteraçãoPendente = true;
        },
        removerAnexo(item) {
            this.reunião.anexos = this.reunião.anexos.filter(a => a != item)
            this.alteraçãoPendente = true;
        },
        adicionarSetor() {
            this.reunião.setores.push(this.novoSetor);
            this.novoSetor = null;
        },
        removerSetor(id) {
            this.reunião.setores = this.reunião.setores.filter(s => s.id != id)
        },
    },
}
</script>

<style scoped>
.bi-exclamation-circle {
    color: var(--cor-fonte-fraca);
}

.tags a i {
    display: none;
}

.tags a:hover i {
    display: inline;
}

.container-adicionar-setor {
    padding: 5px;
}

.adicionar-setor {
    height: 2rem;
    font-weight: bold;
    padding: 0 16px;
    border: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: transparent !important;
}

i {
    color: var(--cor-erro);
    font-size: 16px;
    transition: all 200ms ease-in;
}

i:hover {
    cursor: pointer;
    transform: scale(1.1);
}
</style>